/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BigClock_Api_Models_SetDeviceSourceModel } from '../models/BigClock_Api_Models_SetDeviceSourceModel';
import type { BigClock_Application_Queries_GetMeteoDashboardData_GetMeteoDashboardDataResponse } from '../models/BigClock_Application_Queries_GetMeteoDashboardData_GetMeteoDashboardDataResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MeteoDashboardService {
    /**
     * @param controlBlockId
     * @returns BigClock_Application_Queries_GetMeteoDashboardData_GetMeteoDashboardDataResponse Success
     * @throws ApiError
     */
    public static getApiMeteoDashboardControlBlock(
        controlBlockId: string,
    ): CancelablePromise<BigClock_Application_Queries_GetMeteoDashboardData_GetMeteoDashboardDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/MeteoDashboard/ControlBlock/{controlBlockId}',
            path: {
                'controlBlockId': controlBlockId,
            },
        });
    }
    /**
     * @param controlBlockId
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static putApiMeteoDashboardControlBlockDevice(
        controlBlockId: string,
        requestBody?: BigClock_Api_Models_SetDeviceSourceModel,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/MeteoDashboard/ControlBlock/{controlBlockId}/device',
            path: {
                'controlBlockId': controlBlockId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
